<ng-container>
  <ng-container>
    <button
      mat-icon-button
      data-automation-id="smt-action-button-save-viewer-config-header"
      (click)="saveConfigHeader()"
      [attr.aria-label]="'ALDEN.ACTIONS.SAVE_VIEWER_CONFIG' | translate"
      [attr.title]="'ALDEN.ACTIONS.SAVE_VIEWER_CONFIG' | translate"
    >
      <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
    </button>
  </ng-container>
</ng-container>

<ng-template>
  <span>{{ 'ALDEN.ACTIONS.SAVE_VIEWER_CONFIG' | translate }}</span>
</ng-template>
